import { render, staticRenderFns } from "./YsyPrivacyPolicy.vue?vue&type=template&id=580781da&scoped=true&"
import script from "./YsyPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./YsyPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./YsyPrivacyPolicy.vue?vue&type=style&index=0&id=580781da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580781da",
  null
  
)

export default component.exports